import { render, staticRenderFns } from "./MsgSever.vue?vue&type=template&id=5dd1658c&scoped=true"
import script from "./MsgSever.vue?vue&type=script&lang=js"
export * from "./MsgSever.vue?vue&type=script&lang=js"
import style0 from "./MsgSever.vue?vue&type=style&index=0&id=5dd1658c&prod&lang=scss&scoped=true"
import style1 from "./MsgSever.vue?vue&type=style&index=1&id=5dd1658c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_7d198ec714527f3eb87755d9f59e0144/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd1658c",
  null
  
)

export default component.exports